module.exports = __webpack_public_path__ + "img/icon_dean_home_bg_card_icon_11.e84a4d16.png";